import { useState, useEffect } from "react";

interface User {
  userToken: string;
  userId: string;
}

interface SessionDetails {
  semesterId: number;
  sessionId: number;
}

interface Role {
  RoleId: string;
  RoleName: string;
  IsSysAdmin: boolean;
}

const useAuth = () => {
  const [user, setUser] = useState<User>(
    JSON.parse(localStorage.getItem("result-manager-auth") || "{}") as User
  );
  const [roles, setRoles] = useState<Role[]>(
    JSON.parse(localStorage.getItem("result-manager-roles") || "[]") as Role[]
  );
  const [sessionDetails, setSessionDetails] = useState<SessionDetails>(
    JSON.parse(
      localStorage.getItem("session-details") || "{}"
    ) as SessionDetails
  );

  useEffect(() => {
    localStorage.setItem("result-manager-auth", JSON.stringify(user));
    localStorage.setItem("result-manager-roles", JSON.stringify(roles));
    localStorage.setItem("session-details", JSON.stringify(sessionDetails));
  }, [user, roles, sessionDetails]);

  return { user, setUser, roles, setRoles, sessionDetails, setSessionDetails };
};

export default useAuth;